import { createIsomorphicFn } from "@tanstack/react-start";
import { getRequestUrl } from "@tanstack/react-start/server";

export const getSiteOrigin = createIsomorphicFn()
  .server(
    () =>
      process.env.SITE_URL?.replace(/\/+$/, "") ||
      getRequestUrl({ xForwardedHost: true, xForwardedProto: true }).origin,
  )
  .client(() => window.location.origin);
